import React from 'react'
import Page from './page'
import './contact.css'

function Contact () {
  return (
    <Page>
      <header className="contact-header">
        <h1>Contact Us</h1>
      </header>
      <section className="contact-info">
        <h4>Dig Two Graves Productions</h4>
        <p>
          1953 Cheremoya Ave #7
          <br />LA, CA 90068
          <br />+1 (920) 284-2626
          <br /><a href="mailto:info@digtwograves.com">info@digtwograves.com</a>
        </p>
      </section>
      <section className="contact-info">
        <h4>Publicists</h4>
        <p>
          Big Time PR
          <br /><a href="mailto:sylvia@bigtime-pr.com">Sylvia Desrochers</a> &amp; <a href="mailto:tiffany@bigtime-pr.com">Tiffany Wagner</a>
          <br />+1 (424) 208-3496
        </p>
        <p>
          Falco Ink.
          <br /><a href="mailto:apriltonsil@falcoink.com">April Tonsil</a> &amp; <a href="mailto:shannontreusch@falcoink.com">Shannon Treusch</a>
          <br />+1 (212) 445-7100
        </p>
      </section>
      <section className="contact-info">
        <h4>Distribution</h4>
        <p>
          Area 23a
          <br /><a href="mailto:kirt@area23a.com">Kirt Eftekhar</a>
          <br />+1 (310) 710-4378
        </p>
        <p>For screening inquires please contact <a href="mailto:kirt@area23a.com">Kirt Eftekhar</a>.</p>
      </section>
    </Page>
  )
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/contact.js